// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"345":"10976080cfe7f5b661c1","968":"1274e8b90123bdc7c0fa"}[chunkId] + ".css";
};